import { render, staticRenderFns } from "./ArtificialInsemination.vue?vue&type=template&id=d8652d58&scoped=true&"
import script from "./ArtificialInsemination.vue?vue&type=script&lang=js&"
export * from "./ArtificialInsemination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8652d58",
  null
  
)

export default component.exports